/** Daily strength deadline (IST). Warning at 10:30, final reminder at 11:00. */
export const MDMS_WARNING_HOUR = 10;
export const MDMS_WARNING_MINUTE = 30;
export const MDMS_DEADLINE_HOUR = 11;
export const MDMS_DEADLINE_MINUTE = 0;

/** @returns {'none'|'warning'|'final'} */
export function getMdmsReminderPhase(date = new Date()) {
  const mins = istMinutesSinceMidnight(date);
  const warningAt = MDMS_WARNING_HOUR * 60 + MDMS_WARNING_MINUTE;
  const deadlineAt = MDMS_DEADLINE_HOUR * 60 + MDMS_DEADLINE_MINUTE;
  if (mins >= deadlineAt) return 'final';
  if (mins >= warningAt) return 'warning';
  return 'none';
}

export function istMinutesSinceMidnight(date = new Date()) {
  const { hour, minute } = getIstDateParts(date);
  return hour * 60 + minute;
}

export function getIstDateParts(date = new Date()) {
  const utcMs = date.getTime() + date.getTimezoneOffset() * 60000;
  const ist = new Date(utcMs + 5.5 * 60 * 60000);
  return { hour: ist.getHours(), minute: ist.getMinutes() };
}

/** Today's calendar date in IST as YYYY-MM-DD. */
export function getIstDateIso(date = new Date()) {
  const utcMs = date.getTime() + date.getTimezoneOffset() * 60000;
  const ist = new Date(utcMs + 5.5 * 60 * 60000);
  const y = ist.getFullYear();
  const m = String(ist.getMonth() + 1).padStart(2, '0');
  const d = String(ist.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** @deprecated use getMdmsReminderPhase */
export function getIstHour(date = new Date()) {
  return getIstDateParts(date).hour;
}

/** @deprecated use getMdmsReminderPhase */
export function isAfterIstHour(hour, date = new Date()) {
  return getIstHour(date) >= hour;
}
